module.exports = __webpack_public_path__ + "img/banner-desktop.1c4fd509.png";